interface LanguageOption {
  value: string;
  label: string;
}

export const options: LanguageOption[] = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
];
